import { CylinderBufferGeometry, RingBufferGeometry } from 'three';
import { mergeBufferGeometries } from '../../../../vendors/three.examples/BufferGeometryUtils';

const getCylinder = (r, h, open = false) => new CylinderBufferGeometry(r, r, h, 64, 1, open);
const getCylinder2 = (r1, r2, h, open = false) => new CylinderBufferGeometry(r1, r2, h, 64, 1, open);

const getRing = (r1, r2, shiftY) => {
    const geom = new RingBufferGeometry(r1, r2, 64);

    geom.rotateX(Math.PI * 0.5);
    geom.translate(0, shiftY, 0);

    return geom;
};

export const getPlateGeometry = ({
    innerR, outerR, height, innerHeight
}) => mergeBufferGeometries([
    getCylinder(innerR, innerHeight),
    getCylinder2(innerR, innerR * 0.9, height, true),
    getCylinder(outerR, height, true),
    getRing(innerR, outerR, height * 0.5),
    getRing(innerR * 0.9, outerR, -height * 0.5)
]);
